/**
 * Bing map src doc
 */
var BingMap = /** @class */ (function () {
    function BingMap(maps) {
        this.maps = maps;
    }
    BingMap.prototype.getBingMap = function (tile, key, type, language) {
        var quadKey = '';
        for (var i = this.maps.zoomLevel; i > 0; i--) {
            var digit = 0;
            var mask = 1 << (i - 1);
            if ((tile.x & mask) !== 0) {
                digit++;
            }
            if ((tile.y & mask) !== 0) {
                digit += 2;
            }
            quadKey = quadKey + '' + digit;
        }
        var layerType = '';
        if (type === 'Aerial') {
            layerType = 'A,G';
        }
        else if (type === 'AerialWithLabel') {
            layerType = 'A,G,L';
        }
        else {
            layerType = 'G,VE,BX,L,LA';
        }
        return 'http://ak.dynamic.t2.tiles.virtualearth.net/comp/ch/' + quadKey + '?mkt=' + language + '&ur=IN&it=' + layerType +
            '&shading=hill&og=45&n=z&Key=' + key;
    };
    return BingMap;
}());
export { BingMap };
